//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";
import {insightService} from "@/insight-service";
import {missionService} from "@/misson-service";
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-user-avatar.js';
import Graph from "./Graph";
import MissionDialog from "./MissionDialog";
import Drilldown from "@/components/mission/Drilldown";

export default {
  name: "Missions",
  components: {
    Drilldown,
    Graph,
    MissionDialog,
  },

  props: {
    model: {
      type: Object,
      value: undefined,
    },
    profile: {
      type: Boolean,
      default: false,
    },
    librarianView: {
      type: Boolean,
      default: false
    },
    all: {
      type: Boolean,
      value: false,
    }
  },

  mounted() {
    this.fetchMissions(!this.profile);
  },

  data: () => ({
    closeOnClick: true,
    priorities: [],
    loading: false,
    missions: [],
    showDialog: false,
    editMode: false,
    mission: {},
    selectedTab: 'tab-ongoing',
    sortBy: 'title',
    sortDesc: false,
    lessFields: [
      {
        key: "title",
        label: 'Name',
        sortable: true,
        thStyle: {
          'width': '10%'
        },
      },
      {
        key: "priority",
        label: 'Priority',
        sortable: true,
        thStyle: {
          'width': '10%'
        },
      },
      {
        label: 'Goal',
        key: 'goal',
        thStyle: {
          'width': '12%'
        },
      },
      {
        label: 'Evolution',
        key: 'evolution',
        thStyle: {
          'width': '25%'
        },
      },
      {
        key: 'participants',
        label: 'Participants',
        thStyle: {
          'width': '20%'
        },
      },
      {
        key: 'actions',
        label: 'Action',
        thStyle: {
          'width': '12%'
        },
      }
    ],
    fields: [
      {
        key: "title",
        label: 'Name',
        sortable: true,
        thStyle: {
          'width': '10%'
        },
      },
      {
        key: "priority",
        label: 'Priority',
        sortable: true,
        thStyle: {
          'width': '8%'
        },
      },
      {
        key: 'created',
        label: 'Created',
        sortable: true,
        thStyle: {
          'width': '9%'
        },
      },
      {
        label: 'Goal',
        key: 'goal',
        thStyle: {
          'width': '10%'
        },
      },
      {
        label: 'Evolution',
        key: 'evolution',
        thStyle: {
          'width': '25%'
        },
      },
      {
        key: 'participants',
        label: 'Participants',
        thStyle: {
          'width': '20%'
        },
      },
      {
        label: 'Done Reviews',
        key: 'annotations',
        sortable: true,
        thStyle: {
          'width': '10%'
        },
      },
      {
        key: 'actions',
        label: 'Action',
        thStyle: {
          'width': '8%'
        },
      }
    ]
  }),

  computed: {
    ...mapGetters(["currentClient", "projectId"]),
    getFields() {
      return this.librarianView || this.profile ? this.lessFields : this.fields;
    },
  },

  watch: {
    model: function (value) {
      this.fetchMissions(value);
    },
  },

  methods: {
    getLeftStyleAvatar(index) {
      if (index === 0) {
        return 1;
      }
      return index * 20;
    },
    missionData(mission) {
      return missionService.dataPoints(mission);
    },

    missionOutcomeData(mission) {
      return missionService.outcomeDataPoints(mission);
    },

    // horizontal base line
    missionGoalLine(mission) {
      return missionService.goalLine(mission);
    },

    missionDates(mission) {
      return missionService.evaluationLabels(mission);
    },
    startAction(mission) {
      this.$router.push({name: "annotation", params: {id: mission.uid}});
    },
    deleteAction(uid) {
      this.$refs.deleteMission.input = uid;
      this.$refs.deleteMission
          .execute()
          .then(() => {
            this.displaySuccess(this.$t("model.missions.delete.success"));
            this.fetchMissions(true);
          })
          .catch((error) => {
            this.displayError(error);
          });
    },
    openEdit(mission) {
      this.editMode = true;
      this.showDialog = true;
      this.mission = mission;
    },
    openCreate() {
      this.editMode = false;
      this.showDialog = true;
    },
    getDate(date) {
      return insightService.formatDateWithYear(date);
    },
    getAnnotations(missionId, type) {
      var nuxeo = this.$refs.aiCloudConnect.client;
      insightService
          .getAnnotationsForModel(nuxeo, this.projectId, missionId, type)
          .then(response => {
            return response.doc_count;
          })
          .catch(error => {
            console.error(error);
          });
    },
    navigateToMission(uid) {
      this.$router.push({name: "mission", params: {id: uid}});
    },
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
      setMissions: "setMissions",
    }),

    fetchMissions(forModel) {
      this.loading = true;
      this.showDialog = false;
      // We take always the model live id
      if (forModel && this.model && !this.all) {
        const modelLiveId = this.model.uid;
        this.$refs.missions_pp.params.queryParams = `AND ai_mission:model = '${modelLiveId}'`;
        this.callFetchMissions();
      }
      if (this.all) {
        this.$refs.missions_pp.params.queryParams = " ";
        this.callFetchMissions();
      }
    },

    callFetchMissions() {
      this.$refs.missions_pp
          .fetch()
          .then((results) => {
            results.entries.forEach(mission => {
              mission.availableReviews = this.getAnnotations(mission.uid, 'ANNOTATED'),
                  mission.doneReviews = this.getAnnotations(mission.uid, 'MISSING')
            });
            this.missions = results.entries;
            this.setMissions(this.missions);
            this.loading = false;
          })
          .catch((error) => {
            this.displayError(error);
            this.loading = false;
          });
    },

    cancel() {
      this.showDialog = false;
    },
    toggleMissionTab(tab) {
      this.selectedTab = tab;
    },
    getAssignees(item) {
      return item.properties['ai_mission:assignees'];
    },
    editAvatar(item) {
      if (!item || item === 'null') return '';
      return item.slice(0, 1);
    },
    priorityStyle(priority) {
      return {
        'color': `${insightService.getPriorityIcon(priority).color}`,
        'border-color': `${insightService.getPriorityIcon(priority).color}`
      }
    },
    currentGoal(mission) {
      const goalValues = this.missionData(mission);
      return goalValues && goalValues[goalValues.length - 1];
    },
    currentGoalWidth(targetGoal, currentGoal) {
      if (currentGoal > targetGoal)
        return {
          width: '100%'
        }
      return {
        width: currentGoal / targetGoal + '%'
      }
    }
  },
};
